import React from "react";
import { useParams,Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi"; 
import ScrollToTopButton from "./ScrollToTopButton";


const OrthoServices = () => {
  const { id } = useParams(); // Get the route param from URL
  const serviceId = parseInt(id || 1);

  const orthoServices = [
    {
      id: 1,
      title: "TRAUMA SURGERIES",
      description: "Trauma Surgeries involve the urgent treatment of injuries resulting from accidents, falls, or other high-impact incidents. These surgeries are performed to repair broken bones, damaged tissues, and restore normal function to the injured area. With expert surgical intervention and timely care, trauma surgery aims to stabilize the patient, prevent complications, and promote fast recovery. Our team ensures personalized care for every critical case.",
      image: "/ortho/ortho5.jpg",
    },
    {
      id: 2,
      title: "KNEE REPLACEMENT",
      description: "Knee Replacement surgery is performed to relieve pain and restore function in severely diseased knee joints. It involves replacing the damaged parts of the knee with artificial implants that mimic natural movement. This procedure is ideal for patients suffering from chronic arthritis or injury-related joint damage. With modern techniques, recovery is quicker, and patients can return to an active lifestyle with improved mobility and comfort.",
      image: "/ortho/ortho6.webp",
    },
    {
      id: 3,
      title: "HIP REPLACEMENT",
      description: "Hip Replacement surgery is a highly effective procedure for relieving hip pain caused by arthritis, injury, or wear-and-tear. In this surgery, the damaged bone and cartilage are replaced with artificial components to restore joint function. It helps improve mobility, reduce discomfort, and enhance the quality of life. With advanced surgical techniques and personalized rehabilitation, patients can regain strength and return to their normal activities smoothly and safely.",
      image: "/ortho/ortho4.webp",
    },
    {
      id: 4,
      title: "SHOULDER SURGERIES",
      description: "Shoulder Surgeries are performed to treat conditions like rotator cuff tears, dislocations, frozen shoulder, and arthritis. These procedures aim to relieve pain, restore strength, and improve the shoulder’s range of motion. Depending on the severity, surgeries may range from arthroscopic (minimally invasive) techniques to full joint replacements. Our experienced orthopedic team uses the latest surgical advancements to ensure optimal recovery and long-term shoulder health, helping patients return to daily activities with ease.",
      image: "/ortho/ortho3.webp",
    },
    {
      id: 5,
      title: "SPINE SURGERIES",
      description: "Spine Surgery involves procedures aimed at relieving pain and restoring function in patients with spinal disorders. It can treat conditions like herniated discs, spinal stenosis, scoliosis, and degenerative disc disease. With advanced techniques like minimally invasive surgery, patients experience faster recovery, reduced pain, and minimal scarring. Spine surgery not only improves mobility but also enhances the quality of life. At our clinic, we offer expert care using state-of-the-art technology to ensure safe and effective outcomes.",
      image: "/ortho/ortho1.webp",
    },
    {
      id: 6,
      title: "FOOT & ANKLE SURGERIES",
      description: "Foot & Ankle Surgeries are specialized procedures designed to treat a wide range of conditions such as fractures, ligament injuries, bunions, flat feet, and arthritis. These surgeries help restore mobility, reduce chronic pain, and improve overall foot alignment and function. Whether it’s a minimally invasive procedure or complex reconstruction, our expert orthopedic team ensures precision and personalized care. With advanced surgical techniques and tailored rehabilitation plans, we aim for faster recovery and long-term relief for every patient.",
      image:  "/ortho/ortho2.webp",
    },
    {
      id: 7,
      title: "PEDIATRIC ORTH. SURGERIES",
      description: "Pediatric Orthopedic Surgeries focus on treating musculoskeletal issues in infants, children, and adolescents. These surgeries address conditions like congenital deformities, limb length discrepancies, fractures, and growth plate injuries. Children's bones and joints are still developing, so treatments are tailored to support healthy growth. Minimally invasive techniques and advanced imaging help ensure accurate diagnosis and effective outcomes. Early intervention can prevent complications and promote normal development. Pediatric orthopedic care is designed with gentle, child-friendly approaches for quicker recovery and long-term well-being.",
      image:  "/ortho/ortho7.webp",
    },
    {
      id: 8,
      title: "ARTHROSCOPIES SURGERY",
      description: "Arthroscopic Surgery is a minimally invasive procedure used to diagnose and treat joint problems. It involves inserting a small camera (arthroscope) into the joint through a tiny incision, allowing the surgeon to view the inside on a screen. Commonly performed on the knee, shoulder, elbow, or ankle, it helps repair torn ligaments, remove damaged cartilage, or treat inflammation. This technique causes less tissue damage, leading to reduced pain, minimal scarring, and faster recovery. Arthroscopy is often a day-care procedure, enabling patients to return to normal activities sooner. It's a safe and effective method for managing joint-related issues.",
      image:  "/ortho/ortho8.webp",
    },


  ];

  const service = orthoServices.find((s) => s.id === serviceId) || orthoServices[0];

  return (
    <div className="min-h-screen bg-white mt-[120px]">
      <div className="bg-blue-600 py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-1/2 mb-6 md:mb-0">
              <h1 className="text-4xl font-bold text-white mb-4">
                What Do You Understand by {service.title}?
              </h1>
              <p className="text-white text-lg">
                {service.description}
              </p>
               <div className="mt-6 flex flex-col sm:flex-row gap-4">
                           <Link
               to="/specialities"
               className="inline-flex items-center text-white text-lg hover:underline"
             >
               <FiArrowLeft className="mr-2 text-white text-2xl" />
               Back 
             </Link>
             <a href="tel:8788061100">
  <button className="bg-white text-blue-600 px-6 py-3 rounded-md hover:bg-gray-100 transition-colors font-medium">
    Call Now
  </button>
</a>

                           </div>
            </div>
            <div className="md:w-2/5">
              <div className="bg-white rounded-full p-4">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-auto rounded-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export default OrthoServices;
